<template>
  <Flex direction="column">
    <BaseText>
      {{ $t('wavy_onboarding.migrate_website.description') }}
    </BaseText>
    <BaseText bold>
      {{ `${$t('wavy_onboarding.migrate_website.summary_heading')}:` }}
    </BaseText>
    <div>
      <BaseText iconBefore="check">
        {{ $t('wavy_onboarding.migrate_website.summary_1') }}
      </BaseText>
      <BaseText iconBefore="check">
        {{ $t('wavy_onboarding.migrate_website.summary_2') }}
      </BaseText>
      <BaseText iconBefore="check">
        {{ $t('wavy_onboarding.migrate_website.summary_3') }}
      </BaseText>
      <BaseText iconBefore="check">
        {{ $t('wavy_onboarding.migrate_website.summary_4') }}
      </BaseText>
    </div>
    <BaseAlert
      :text="$t('wavy_onboarding.migrate_website.alert')"
      color="warning"
    />
    <BaseCard>
      <BaseCheckbox
        v-model="termsAccepted"
        required
        :label="$t('wavy_onboarding.migrate_website.terms')"
        :description="$t('wavy_onboarding.migrate_website.no_website_notice')"
        v-test="'migrate-website-terms'"
      />
    </BaseCard>
  </Flex>
</template>

<script
  setup
  lang="ts"
>
const termsAccepted = ref(false);
</script>
